import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { useConfigUI } from '@/features/config/context'
import { UpdateFlowSensor } from '@/types/hydraulic'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'

async function updateFlowSensor(payload: UpdateFlowSensor): Promise<void> {
  await flowSensorApi.update(payload)
}

function useEditFlowSensor() {
  const queryClient = useQueryClient()
  const { closeSidebar, setAllowSidebar } = useConfigUI()

  return useMutation((payload: UpdateFlowSensor) => updateFlowSensor(payload), {
    onMutate: () => setAllowSidebar(false),
    onSuccess: async () => {
      await queryClient.refetchQueries([queryKeys.flowSensor])
      await queryClient.refetchQueries([queryKeys.flowValve])
      toast.success('Edit Flow Sensor Success')

      setAllowSidebar(true)
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
    onSettled: () => {
      setAllowSidebar(true)
    },
  })
}

export default useEditFlowSensor
